import { IResource } from '@models/Resource.model';

export const getResourceSource = (resource: IResource) => {
  if (resource.ownerStudioId) {
    return 'Internal';
  }

  if (resource.manufacturerName) {
    return resource.manufacturerName;
  }

  return 'Unknown';
};
